const PT = require("prop-types");
const React = require("react");
const createReactClass = require("create-react-class");
const _ = require("lodash");
const withSetURL = require("../hoc/withSetURL");
const Sounds = require("../util/Sounds");
const URLMake = require("../../../shared/URLMake");
const {parseURL} = require("../../../shared/URLParser");
const {requiresFullDocumentNavigation} = require("../../../shared/ElevRoutes");

// Ignore touchEnd navigation when the finger moved enough to count as scrolling.
const TAP_MOVE_THRESHOLD_PX = 10;

/*
	An arbitrary link to another part of the page. Unlike standard <a href>, clicking
	this link does not trigger a page reload. For student facing pages that could be
	part of the demo, use StudentLink instead (which wraps Link). You can pass in any
	of the props below to StudentLink and they will be passed back into Link from there.

	===========================
	NOTE:
		When supplying the "to" prop, a page state object is preferred, but you can use
		a URL string for the time being.
	===========================
*/

// Helper to apply higher-order components.
const augment = function(Component) {
	Component = withSetURL(Component);
	return Component;
};
module.exports = augment(
	createReactClass({
		displayName: "Link",

		propTypes: {
			// path of the route to link to. SEE NOTE ABOVE
			to: PT.oneOfType([PT.string, PT.object]),
			// ID to go on the <a> element, if any.
			id: PT.string,
			// Classes to go on the <a> element, if any.
			className: PT.string,
			// Styles to go on the <a> element, if any.
			style: PT.object,
			// Whether the link is external and should leave this page entirely.
			isExternal: PT.bool,
			// Whether a click should actually be registered.
			canClick: PT.func,
			// Extra click functionality (e.g. close grade modal after link click).
			clickAction: PT.func,
			// Name of the sound file to play on click.
			clickSound: PT.string,
			// Function to run for mouseenter event.
			onMouseEnter: PT.func,
			// Function to run for mouseleave event.
			onMouseLeave: PT.func,
			// Whether to allow keyboard events when link has focus. Default false.
			allowKeyboard: PT.bool,
			// Whether to open the link in a new tab
			isNewTab: PT.bool,
			// Whether to remove focus from the element upon rendering.
			noFocus: PT.bool,
			// Prevent touch events from propagating to parents
			// Only supported with isNewTab = true, for now
			stopTouchPropagation: PT.bool,
			// If true, cursor is wonky hand-shaped custom BA cursor instead of regular pointer.
			useWonkyCursor: PT.bool,
			// If true, cursor is wonky shovel-shaped custom BA cursor instead of regular pointer.
			useWonkyArrowCursor: PT.bool,
			// Do clickAction even if isNewTab is true
			forceActionOnNewTab: PT.bool,
			// Use a pointer (the can-click hover icon) when there's a click
			// action. Use a cursor (the shovel, regular navigation) otherwise.
			usePointerOnlyIfClickAction: PT.bool,
			onLinkClick: PT.func,

			// Injected by HOCs
			setURL: PT.func.isRequired,
		},

		componentDidMount: function() {
			if (this.props.noFocus) {
				setTimeout(() => this.blurLink(), 0);
			}
		},

		getHref: function() {
			const {to} = this.props;
			if (!to) return null;

			return URLMake.toURL(to);
		},

		shouldBeNewPageLoad: function(href) {
			if (this.props.isExternal) return true;
			const page = parseURL(href);
			return requiresFullDocumentNavigation(page);
		},

		click: function(evt) {
			if (_.isFunction(this?.linkRef?.click)) {
				this.linkRef.click();
			}
		},

		resetTouchTracking: function() {
			this.touchStartX = null;
			this.touchStartY = null;
			this.touchMoved = false;
		},

		onTouchStart: function(evt) {
			const touch = evt.changedTouches[0];
			if (!touch) return;
			this.touchStartX = touch.pageX;
			this.touchStartY = touch.pageY;
			this.touchMoved = false;
		},

		onTouchMove: function(evt) {
			if (this.touchMoved) return;
			const touch = evt.changedTouches[0];
			if (!touch || this.touchStartX == null) return;
			const dx = Math.abs(touch.pageX - this.touchStartX);
			const dy = Math.abs(touch.pageY - this.touchStartY);
			if (dx > TAP_MOVE_THRESHOLD_PX || dy > TAP_MOVE_THRESHOLD_PX) {
				this.touchMoved = true;
			}
		},

		onTouchEnd: function(evt) {
			// Scroll/drag over the link: suppress navigation and the ghost click.
			if (this.touchMoved) {
				evt.preventDefault();
				this.resetTouchTracking();
				return;
			}
			this.onClick(evt);
			this.resetTouchTracking();
		},

		onClick: function(evt, forceLeave) {
			const {
				canClick,
				allowKeyboard,
				setURL,
				clickSound,
				clickAction,
				onLinkClick,
			} = this.props;
			if (canClick && !canClick()) {
				evt.preventDefault();
				evt.stopPropagation();
				return;
			}
			if (onLinkClick) {
				onLinkClick();
			}

			//Let default behavior occur for ctrl+click or ⌘ + click
			if (evt.ctrlKey || evt.metaKey) return;
			evt.preventDefault();
			if (!allowKeyboard) {
				evt.currentTarget && evt.currentTarget.blur();
			}
			const href = this.getHref();

			if (href && this.shouldBeNewPageLoad(href)) {
				if (global.window) {
					window.location = href;
				}
			} else if (href) {
				setURL(href);
			}
			if (clickSound) {
				Sounds.playSound(clickSound);
			}
			if (clickAction) {
				clickAction(evt);
			}
		},

		blurLink: function() {
			this.linkRef && this.linkRef.blur();
		},

		getRef: function() {
			return this.linkRef;
		},

		render: function() {
			let cursor;
			if (this.props.useWonkyCursor) {
				cursor = "url(/assets/images/cursors/wonky-hand-point.cur), pointer";
			} else if (this.props.useWonkyArrowCursor) {
				cursor = "cursor";
			} else {
				cursor = "pointer";
			}

			const aAttrs = {
				className: this.props.className,
				id: this.props.id,
				onMouseEnter: this.props.onMouseEnter,
				onMouseLeave: this.props.onMouseLeave,
				// BUG: Long-press on mobile/tablet triggers onContextMenu (the browser's context
				// menu gesture). Calling blurLink here immediately removes focus, which can
				// interfere with the browser showing its native context menu — especially on
				// Android where long-press is how users "open link in new tab". Consider removing
				// this handler for isNewTab links, or removing it entirely.
				onContextMenu: this.blurLink,
				// FIX (2026): onTouchEnd was unconditionally calling this.onClick, which calls
				// evt.preventDefault(). On mobile, preventDefault() on touchend cancels the
				// subsequent click event entirely — so for isNewTab links the browser never got
				// to handle the tap natively with target="_blank". Instead, setURL() was called
				// and React Router showed a 404 for non-route paths like PDFs.
				// Fix: skip onTouchEnd for isNewTab links so the browser handles the tap itself.
				onTouchStart: this.props.isNewTab ? undefined : this.onTouchStart,
				onTouchMove: this.props.isNewTab ? undefined : this.onTouchMove,
				onTouchEnd: this.props.isNewTab ? undefined : this.onTouchEnd,
				onTouchCancel: this.props.isNewTab
					? undefined
					: this.resetTouchTracking,
			};
			if (
				!this.props.usePointerOnlyIfClickAction ||
				typeof this.props.clickAction === "function"
			) {
				// BUG: _.extend(this.props.style, {cursor}) mutates the style object passed
				// in as a prop. _.extend modifies its first argument in place, so if a parent
				// passes a shared/reused style object it will be permanently modified with the
				// cursor value. This can cause subtle, hard-to-trace style bleed across
				// components. Should be: _.extend({}, this.props.style, {cursor})
				// or the spread equivalent: {...this.props.style, cursor}
				aAttrs.style = _.extend(this.props.style, {cursor});
			}

			const href = this.getHref();
			if (href || this.props.clickAction) {
				aAttrs.href = href;

				if (this.props.isNewTab) {
					// SECURITY: target="_blank" without rel="noopener noreferrer" allows the
					// opened page to access window.opener and redirect the parent tab (tabnapping
					// attack). Modern browsers (Chrome 88+, Safari 12.1+) now default to
					// noopener on _blank links, but older browsers and some mobile WebViews do
					// not. Best practice is to always set rel="noopener noreferrer" explicitly.
					aAttrs.target = "_blank";
					aAttrs.rel = "noopener noreferrer";

					// EDGE CASE: When both stopTouchPropagation and forceActionOnNewTab are
					// true, their interaction is undefined. stopTouchPropagation sets onClick
					// to only call stopPropagation(), then forceActionOnNewTab overwrites onClick
					// with clickAction — so clickAction runs on click but NOT on touch (where
					// onTouchEnd is also just stopPropagation). If both props are ever used
					// together, touch interactions will silently skip the click action.
					if (this.props.stopTouchPropagation) {
						aAttrs.onClick = evt => evt.stopPropagation();
						aAttrs.onTouchStart = evt => evt.stopPropagation();
						aAttrs.onTouchEnd = evt => evt.stopPropagation();
					}
					if (this.props.forceActionOnNewTab) {
						aAttrs.onClick = this.props.clickAction;
					}
				} else {
					aAttrs.onClick = this.onClick;
				}
			}
			// ACCESSIBILITY + DEPRECATION: Keyboard events are suppressed by default
			// (unless allowKeyboard is set), making links unreachable via keyboard for
			// users who rely on Tab/Enter navigation. This is a significant accessibility
			// gap — WCAG 2.1 requires all interactive elements to be keyboard operable.
			// Additionally, onKeyPress is deprecated in all modern browsers (Chrome, Firefox,
			// Safari all log warnings) and will eventually be removed. It should be replaced
			// with onKeyDown. The broader default-off keyboard behavior should be revisited.
			if (!this.props.allowKeyboard) {
				aAttrs.onKeyDown = evt => evt.preventDefault();
				aAttrs.onKeyUp = evt => evt.preventDefault();
				aAttrs.onKeyPress = evt => evt.preventDefault();
			}

			return (
				<a {...aAttrs} ref={a => (this.linkRef = a)}>
					{this.props.children}
				</a>
			);
		},
	})
);
